import { makeStyles } from "@mui/styles";
import React from 'react';
import img from '../../assetes/image/dp1.jpeg';
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    image: {
        height: '300px',
        borderRadius: '20px',
        // marginBottom: '60px',
        marginTop: '20px',
        filter: 'grayscale(1)', /* Webkit Nightlies & Chrome Canary */
        transition: 'all .8s ease-in-out',
        '&:hover': {
            filter: 'grayscale(0)',
            transform: 'scale(1.05)'
        }
    }
}))
export default function Avatar() {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <img src={img} alt='' className={classes.image} />
        </div>
    )
}
